var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThoughtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 30.6667C46 32.0222 45.4615 33.3222 44.503 34.2808C43.5445 35.2393 42.2444 35.7778 40.8889 35.7778H10.2222L0 46V5.11111C0 3.75556 0.53849 2.45553 1.49701 1.49701C2.45553 0.53849 3.75556 0 5.11111 0H40.8889C42.2444 0 43.5445 0.53849 44.503 1.49701C45.4615 2.45553 46 3.75556 46 5.11111V30.6667Z",
    fill: "#FF8A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9538 21.4735C24.1465 21.4735 25.1134 20.5066 25.1134 19.3139C25.1134 18.1212 24.1465 17.1543 22.9538 17.1543C21.7611 17.1543 20.7942 18.1212 20.7942 19.3139C20.7942 20.5066 21.7611 21.4735 22.9538 21.4735Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0712 21.4735C39.264 21.4735 40.2309 20.5066 40.2309 19.3139C40.2309 18.1212 39.264 17.1543 38.0712 17.1543C36.8785 17.1543 35.9116 18.1212 35.9116 19.3139C35.9116 20.5066 36.8785 21.4735 38.0712 21.4735Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83638 21.4735C9.02911 21.4735 9.99601 20.5066 9.99601 19.3139C9.99601 18.1212 9.02911 17.1543 7.83638 17.1543C6.64365 17.1543 5.67676 18.1212 5.67676 19.3139C5.67676 20.5066 6.64365 21.4735 7.83638 21.4735Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThoughtIcon);
export default __webpack_public_path__ + "static/media/thought-icon.5b6572dfadb6b54ded07c528b41b24ec.svg";
export { ForwardRef as ReactComponent };